import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks";
import { MadfarmStaticSelect } from "../../ui/molecules/select/newSelect/static";
import { OptionType } from "../../utils";
import { GetHeadQuarter, resetGetAllSot } from "./slice";

interface Props {
    disabled?: boolean,
    onChange: (value: string | undefined) => void
    value?: string | null
    defaultValue?: string
}

export function SOTFilter(props: Props) {
    const sotState = useAppSelector(state => state.headQuarter)
    const dispatch = useAppDispatch()
    const [headquarter, setHeadquarters] = useState<OptionType[]>([])
    const [selectedSot, setSelectedSot] = useState<string | undefined>()

    useEffect(() => {
        dispatch(GetHeadQuarter(sotState.sotFilters))
    }, [])

    useEffect(() => {
        if (sotState.responseHeadQuarterStatus === 'successfully') {
            if (sotState.responseHeadQuarter) {
                const data = sotState.responseHeadQuarter.data
                const newObjects: OptionType[] = data.map(d => {
                    return { value: d.id, label: `${d.code}` } as OptionType
                })
                setHeadquarters(newObjects)
            }

            dispatch(resetGetAllSot())
        }
    }, [sotState.responseHeadQuarterStatus])

    return (
        <MadfarmStaticSelect
            isClearable
            placeholder={'Sede'}
            value={props.value}
            defaultValue={props.defaultValue}
            options={headquarter}
            disabled={props.disabled}
            onChange={(value) => {
                //@ts-ignore
                const newValue = value !== null ? value?.value : null;
                props.onChange(newValue);
            }}
            noOptionsMessage={"Nessuna sede trovata"}
        />
    )
}